import React from 'react';

import MetaDataMarkup from 'components/MetaDataMarkup';
import { gmConfig } from 'helpers/config';
import ContactPageView from 'views/ContactPage';
import buildPageAnalytics from 'helpers/buildPageAnalytics';
import { CONTACT_PAGE_NAME } from 'constants/pageNames';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

const TITLE = 'Contact Us';
const DESCRIPTION =
  'Contact The Bash to help you book entertainment or signup for a membership today. Our friendly staff is ready to speak with you.';

const ContactPage = () => {
  const OPEN_GRAPH_PROPS = {
    DESCRIPTION,
    TITLE,
    type: 'website',
    url: `https://${gmConfig.domains.www}/contact`,
  };

  return (
    <>
      <MetaDataMarkup title={TITLE} description={DESCRIPTION} openGraphProps={OPEN_GRAPH_PROPS} />
      <ContactPageView />
    </>
  );
};

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      return buildPageAnalytics(CONTACT_PAGE_NAME);
    })
);

export default ContactPage;
